export default {

  namespaced: true,

  state: () => ({

    commissions: {},
    commission_sum: {}

  }),

  mutations: {
    setCommissionsSum(state, data) {
      state.commission_sum = data
    },
    setCommissions(state, data) {
      state.commissions = data
    }

  },

  actions: {
    async getCommission({ dispatch, commit }, params) {
      const data = await axios.get("/erp/commission/commission", { params: params })
      return data
      // await axios.get("/erp/commission/commission", { params: params })
      //   .then(response => {
      //      commit('setCommissionsSum',    response.data.commission_sum)
      //      commit('setCommissions',  response.data.commissions)
      //   }).catch(error => {
      //     commit("userHasLoadedWithError", { error: error }, { root: true });


      //   })
    },

  }
}
